export default __webpack_public_path__ + "static/media/lab-card-bg.6ba3b11a.svg";